import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { TypeCredit } from '../model/type-credit';

@Injectable({
    providedIn: 'root'
  })
  export class TypeCreditService{
  
  constructor(private _restClientService : RestClientService) 
  {}
  
  getListTypeCredit() 
  {
    return this._restClientService.load<TypeCredit[]>('type-credit/type-credits');
  }
  
  getListTypeCreditByWorkflow(workflowcode)
  {
    return this._restClientService.load<TypeCredit[]>('type-credit/type-credits-by-workflow?workflowcode='+workflowcode);
  }
  
  getTypeCreditById(typeCreditId)
  {
    return this._restClientService.load<TypeCredit>('type-credit/type-credit-by-id/'+typeCreditId);
  }

  add(typeCredit) {
    return  this._restClientService.save<TypeCredit>('type-credit/add-type-credit', typeCredit);
  }
  
  update(typeCredit) {
    return  this._restClientService.put<TypeCredit>(`type-credit/update-type-credit`, typeCredit);
  }
  
  getDynamicTypeCredityWorkflowIdAndProfilId(profilId,workflowId) {
    return this._restClientService.load<TypeCredit[]>('type-credit/dynamic-type-credits-by-workdlowid-and-profilid?profilId='+profilId+"&workflowId="+workflowId);
  }
  

}      

    